import api from './api';

const backupService = {
  listar: async () => {
    const { data } = await api.get('/backup');
    return data.data;
  },

  crear: async () => {
    const { data } = await api.post('/backup');
    return data;
  },

   eliminar: async (nombre) => {
    await api.delete(`/backup?nombre=${encodeURIComponent(nombre)}`);
},
};

export default backupService;